
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[slug]",
      function () {
        return require("private-next-pages/work/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/[slug]"])
      });
    }
  